import { getToken } from "firebase/messaging";
import { getMessaging } from "firebase/messaging";
import { initializeApp } from "firebase/app";
// import { onBackgroundMessage } from "firebase/messaging/sw";

// Initialize Firebase
// export const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID,
//   measurementId: process.env.REACT_APP_MEASUREMENT_ID,
// };
export const firebaseConfig = {
  apiKey: "AIzaSyBHwsF8jePINRSdL7kR8RfOPfhl-blbMy4",
  authDomain: "hyperwolf-firebase.firebaseapp.com",
  projectId: "hyperwolf-firebase",
  storageBucket: "hyperwolf-firebase.firebasestorage.app",
  messagingSenderId: "26002918199",
  appId: "1:26002918199:web:37175b74d602a0556068b2",
  measurementId: "G-KJ5TTCH81Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Messaging service
let messaging;
try {
  messaging = getMessaging(app);
} catch (err) {
  console.warn("Firebase Messaging is not supported in this environment.", err);
}
export { messaging };

export async function requestPermission() {
  if (typeof window === 'undefined' || typeof Notification === 'undefined') {
    return;
  }
  //requesting permission using Notification API
  const permission = await Notification.requestPermission();
  if (permission === "granted" && messaging) {
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPID_KEY,
    });

    //We can send token to server
    localStorage.setItem("firebaseDeviceToken", JSON.stringify(token));
  } else if (permission === "denied") {
    //notifications are blocked
    console.log("No registration token available. Request permission to generate one.");

    // store.dispatch(openSnackbar({
    //   content: "No registration token available. Request permission to generate one.",
    //   color: "error"
    // }))
  }
}